(function () {
  if (window.couponPopup && window.couponPopup.initAll) {
    window.couponPopup.initAll();
    return;
  }

  var SELECTOR = '[data-coupon-popup]';
  var MINIMIZED_SELECTOR = '[data-coupon-popup-minimized]';
  var ACTIVE_CLASS = 'is-active';
  var STORAGE_PREFIX = 'coupon-popup-dismissed-at-';
  var MINIMIZED_STORAGE_PREFIX = 'coupon-popup-minimized-hidden-at-';
  var initialized = new WeakSet();
  var openPopups = new Set();
  var previousBodyOverflow = null;

  function getStorageItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStorageItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return false;
    }

    return true;
  }

  function shouldShow(storageKey, hideDays) {
    if (hideDays <= 0) return true;

    var dismissedAt = parseInt(getStorageItem(storageKey), 10);
    if (!dismissedAt) return true;

    var hiddenUntil = dismissedAt + hideDays * 24 * 60 * 60 * 1000;
    return Date.now() >= hiddenUntil;
  }

  function findMinimized(sectionId) {
    var minimizedElements = document.querySelectorAll(MINIMIZED_SELECTOR);

    for (var i = 0; i < minimizedElements.length; i++) {
      if (minimizedElements[i].dataset.sectionId === sectionId) {
        return minimizedElements[i];
      }
    }

    return null;
  }

  function updateBodyScroll() {
    if (openPopups.size > 0) {
      if (previousBodyOverflow === null) {
        previousBodyOverflow = document.body.style.overflow || '';
      }

      document.body.style.overflow = 'hidden';
      return;
    }

    if (previousBodyOverflow !== null) {
      document.body.style.overflow = previousBodyOverflow;
      previousBodyOverflow = null;
    }
  }

  function copyText(text, message) {
    var fallbackMessage = 'コピーできませんでした。コードを選択してコピーしてください。';

    if (!text) {
      message.textContent = fallbackMessage;
      return;
    }

    if (!navigator.clipboard || !navigator.clipboard.writeText) {
      message.textContent = fallbackMessage;
      return;
    }

    navigator.clipboard
      .writeText(text)
      .then(function () {
        message.textContent = 'コピーしました';
      })
      .catch(function () {
        message.textContent = fallbackMessage;
      });
  }

  function initPopup(popup) {
    if (initialized.has(popup)) return;
    initialized.add(popup);

    var sectionId = popup.dataset.sectionId || popup.id || 'default';
    var storageKey = STORAGE_PREFIX + sectionId;
    var minimizedStorageKey = MINIMIZED_STORAGE_PREFIX + sectionId;
    var delaySeconds = Math.max(parseFloat(popup.dataset.delaySeconds) || 0, 0);
    var hideDays = Math.max(parseInt(popup.dataset.hideDays, 10) || 0, 0);
    var closeButtons = popup.querySelectorAll('[data-coupon-popup-close]');
    var closeButton = popup.querySelector('.coupon-popup__close');
    var codeButton = popup.querySelector('[data-coupon-popup-code]');
    var message = popup.querySelector('[data-coupon-popup-message]');
    var minimized = findMinimized(sectionId);
    var reopenButton = minimized ? minimized.querySelector('[data-coupon-popup-reopen]') : null;
    var hideMinimizedButton = minimized ? minimized.querySelector('[data-coupon-popup-hide-minimized]') : null;
    var showTimer = null;

    function showMinimized() {
      if (!minimized || !shouldShow(minimizedStorageKey, hideDays)) return;
      minimized.hidden = false;
    }

    function hideMinimized() {
      if (!minimized) return;
      minimized.hidden = true;
    }

    function openPopup() {
      if (popup.classList.contains(ACTIVE_CLASS)) return;
      hideMinimized();
      popup.classList.add(ACTIVE_CLASS);
      popup.setAttribute('aria-hidden', 'false');
      openPopups.add(popup);
      updateBodyScroll();

      if (closeButton) {
        closeButton.focus();
      }
    }

    function closePopup() {
      if (showTimer) {
        window.clearTimeout(showTimer);
        showTimer = null;
      }

      if (!popup.classList.contains(ACTIVE_CLASS)) return;

      popup.classList.remove(ACTIVE_CLASS);
      popup.setAttribute('aria-hidden', 'true');
      openPopups.delete(popup);
      updateBodyScroll();
      setStorageItem(storageKey, String(Date.now()));
      showMinimized();
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.code === 'Escape' || event.code === 'Esc') {
        closePopup();
      }
    });

    if (codeButton && message) {
      codeButton.addEventListener('click', function () {
        copyText(codeButton.dataset.couponPopupCode, message);
      });
    }

    if (reopenButton) {
      reopenButton.addEventListener('click', openPopup);
    }

    if (hideMinimizedButton) {
      hideMinimizedButton.addEventListener('click', function () {
        hideMinimized();
        setStorageItem(minimizedStorageKey, String(Date.now()));
      });
    }

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.contains(popup)) {
        openPopups.delete(popup);
        updateBodyScroll();
        if (showTimer) window.clearTimeout(showTimer);
      }

      if (minimized && event.target && event.target.contains(minimized)) {
        hideMinimized();
      }
    });

    document.addEventListener('shopify:section:select', function (event) {
      if (event.target && event.target.contains(popup)) {
        openPopup();
      }
    });

    if (window.Shopify && Shopify.designMode) return;
    if (!shouldShow(storageKey, hideDays)) {
      showMinimized();
      return;
    }

    showTimer = window.setTimeout(openPopup, delaySeconds * 1000);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  window.couponPopup = {
    initAll: initAll,
  };
})();
